import React from 'react';
import application_contants from '../../../contants/application_contants';
import PropTypes from 'prop-types';

export default function RegisterButtons(){
  const finalTeams = [
    { legend: 'Winner', name: 'Team Immverse AI' },
    { legend: 'First Runner up', name: 'Team LTRC-SPL' },
    { legend: 'Second Runner up', name: 'Team Somya.ai' }
  ];

  const round1Teams = [
    { name: 'Somya.ai' },
    { name: 'LTRC-SPL' },
    { name: 'CDAC-SVNIT' },
    { name: 'Immverse AI' }
  ];

  return (
    // <section id={section_id} className="about-section">
    <div className="about-section">
      {/* Adding winners image from canva respin.syspin.web account */}
      <div >
        <h2 className="h3-medium section-title title-navy-blue pb-2 about-readmore-title">Winners of the Event</h2>
        <img src={application_contants.winner_event } alt="Final Event Illustration" />
      </div>
      <br></br>
<h5 className="h5-medium section-title title-navy-blue pb-2 about-title ">Final Teams</h5>
      <div className="registers-container">   
        {finalTeams.map((team, index) => (
          <div key={index} className="winner_box">
            <div className="winner-legend" style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', color: '#666' }}>
              {team.legend}
            </div>
            <div className="winner-name" style={{ fontSize: '16px', fontWeight: '600' }}>
              {team.name}
            </div>
          </div>
        ))}
      </div>
<h5 className="h5-medium section-title title-navy-blue pb-2 about-title ">Round 1 Selected Teams</h5>
      <div className="registers-container">   
        {round1Teams.map((team, index) => (
          <div key={index} className="winner_box">
            <div className="winner-name">{team.name}</div>
          </div>
        ))}
      </div>


      <br></br>
      <div className="registers-container">        
        <a href="https://spiredatasets.ee.iisc.ac.in/syspincorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SYSPIN Dataset
        </a>

        <a href="https://spiredatasets.ee.iisc.ac.in/englishttscorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SPICOR TTS_1.0 Dataset
        </a>

        <a href="https://spiredatasets.ee.iisc.ac.in/gujaratittscorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SPICOR TTS_2.0 Dataset
        </a>
      </div>
    </div>
  )
}

RegisterButtons.propTypes = {
  section_id: PropTypes.string.isRequired
}
